import { render, staticRenderFns } from "./DeleteCSImage.vue?vue&type=template&id=01bef092&scoped=true&"
import script from "./DeleteCSImage.vue?vue&type=script&lang=js&"
export * from "./DeleteCSImage.vue?vue&type=script&lang=js&"
import style0 from "./DeleteCSImage.vue?vue&type=style&index=0&id=01bef092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bef092",
  null
  
)

export default component.exports